/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления доступом пользователями к ресурсам
 */

/**
 * Сервис управления доступом пользователей
 */
export class GroupServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения группы.
   * Метод доступен для: admin, service, bti, seller
   */
  GetGroup = (req: GetGroupRequestDto, init?: RequestInit): Promise<GetGroupResponseDto> => {
    return fm.request<GetGroupRequestDto, GetGroupResponseDto>(`${this.host}/access_management/api/v1/group/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка групп.
   * Метод доступен для: admin, service, bti, seller
   */
  GetGroupList = (req?: GetGroupListRequestDto, init?: RequestInit): Promise<GetGroupListResponseDto[]> => {
    return fm.list<GetGroupListRequestDto, GetGroupListResponseDto>(`${this.host}/access_management/api/v1/group/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества групп.
   * Метод доступен для: admin, service, bti, seller
   */
  GetGroupCount = (req?: GetGroupCountRequestDto, init?: RequestInit): Promise<GetGroupCountResponseDto> => {
    return fm.request<GetGroupCountRequestDto, GetGroupCountResponseDto>(`${this.host}/access_management/api/v1/group/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения группы.
   * Поддерживает создание и обновление как UPSERT по Group.id.
   * Метод доступен для: admin, service
   */
  PostGroup = (req: PostGroupRequestDto, init?: RequestInit): Promise<PostGroupResponseDto> => {
    return fm.request<PostGroupRequestDto, PostGroupResponseDto>(`${this.host}/access_management/api/v1/group`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления группы.
   * Метод доступен для: admin, service
   */
  DeleteGroup = (req: DeleteGroupRequestDto, init?: RequestInit): Promise<DeleteGroupResponseDto> => {
    return fm.request<DeleteGroupRequestDto, DeleteGroupResponseDto>(`${this.host}/access_management/api/v1/group/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания группы по шаблону.
   * Метод доступен для: admin, service, bti, seller
   */
  PostGroupByTemplate = (req: PostGroupByTemplateRequestDto, init?: RequestInit): Promise<PostGroupByTemplateResponseDto> => {
    return fm.request<PostGroupByTemplateRequestDto, PostGroupByTemplateResponseDto>(`${this.host}/access_management/api/v1/group/by_template`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод привязки пользователя к группе.
   * Метод доступен для: admin, owner, service, bti, seller
   */
  PutGroupUserAttach = (req: PutGroupUserAttachRequestDto, init?: RequestInit): Promise<PutGroupUserAttachResponseDto> => {
    return fm.request<PutGroupUserAttachRequestDto, PutGroupUserAttachResponseDto>(`${this.host}/access_management/api/v1/group/${encodeURIComponent(req.userGroup.groupId)}/user/${encodeURIComponent(req.userGroup.userId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления привязки пользователя к группе.
   * Метод доступен для: admin, owner, service, bti, seller
   */
  PutGroupUserDetach = (req: PutGroupUserDetachRequestDto, init?: RequestInit): Promise<PutGroupUserDetachResponseDto> => {
    return fm.request<PutGroupUserDetachRequestDto, PutGroupUserDetachResponseDto>(`${this.host}/access_management/api/v1/group/${encodeURIComponent(req.userGroup.groupId)}/user/${encodeURIComponent(req.userGroup.userId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей пользователей и групп.
   * Метод доступен для: admin, owner, service, bti, seller
   */
  GetGroupUserList = (req?: GetGroupUserListRequestDto, init?: RequestInit): Promise<GetGroupUserListResponseDto[]> => {
    return fm.list<GetGroupUserListRequestDto, GetGroupUserListResponseDto>(`${this.host}/access_management/api/v1/group/user/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей пользователей и групп.
   * Метод доступен для: admin, owner, service, bti, seller
   */
  GetGroupUserCount = (req?: GetGroupUserCountRequestDto, init?: RequestInit): Promise<GetGroupUserCountResponseDto> => {
    return fm.request<GetGroupUserCountRequestDto, GetGroupUserCountResponseDto>(`${this.host}/access_management/api/v1/group/user/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения уникальных назначенных атрибутов пользователя.
   * Метод также возвращает группы пользователя в виде атрибута (Claim) {key=GROUP_ID,value=Group.id}.
   * Бизнес-пользователи получают только свои разрешения, поэтому для всех пользователей, кроме admin, owner, service, bti, seller игнорируются GroupClaimFilter.user_id, GroupClaimFilter.user_data, GroupClaimFilter.api_key_hash, а значения для них берутся из токена.
   * Для admin, owner, service, bti, seller при наличии GroupClaimFilter.user_id отдаем разрешения для указанного GroupClaimFilter.user_id и GroupClaimFilter.user_data, при отсутствии GroupClaimFilter.user_id значения берутся из токена.
   * Для admin, service при наличии GroupClaimFilter.api_key_hash возвращаем Claim с учетом только GroupClaimFilter.api_key_hash.
   * Метод доступен для: admin, master, slave, owner, employee, service, bti, seller, external_seller, ltp_first, mrf, manager
   */
  GetGroupClaimList = (req?: GetGroupClaimListRequestDto, init?: RequestInit): Promise<GetGroupClaimListResponseDto[]> => {
    return fm.list<GetGroupClaimListRequestDto, GetGroupClaimListResponseDto>(`${this.host}/access_management/api/v1/group/claim/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества уникальных назначенных атрибутов пользователя.
   * Метод также сосчитает и атрибуты групп {key=GROUP_ID,value=Group.id}.
   * Бизнес-пользователи получают только свои разрешения, поэтому для всех пользователей, кроме admin, owner, service, bti, seller игнорируются GroupClaimFilter.user_id, GroupClaimFilter.user_data, GroupClaimFilter.api_key_hash, а значения для них берутся из токена.
   * Для admin, owner, service, bti, seller при наличии GroupClaimFilter.user_id отдаем разрешения для указанного GroupClaimFilter.user_id и GroupClaimFilter.user_data, при отсутствии GroupClaimFilter.user_id значения берутся из токена.
   * Для admin, service при наличии GroupClaimFilter.api_key_hash возвращаем Claim с учетом только GroupClaimFilter.api_key_hash.
   * Метод доступен для: admin, master, slave, owner, employee, service, bti, seller, external_seller, ltp_first, mrf, manager
   */
  GetGroupClaimCount = (req?: GetGroupClaimCountRequestDto, init?: RequestInit): Promise<GetGroupClaimCountResponseDto> => {
    return fm.request<GetGroupClaimCountRequestDto, GetGroupClaimCountResponseDto>(`${this.host}/access_management/api/v1/group/claim/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод проверки наличия назначенных атрибутов пользователя.
   * Метод также проверит и атрибуты групп {key=GROUP_ID,value=Group.id}.
   * Бизнес-пользователи получают только свои разрешения, поэтому для всех пользователей, кроме admin, owner, service, bti, seller игнорируются GroupClaimFilter.user_id, GroupClaimFilter.user_data, GroupClaimFilter.api_key_hash, а значения для них берутся из токена.
   * Для admin, owner, service, bti, seller при наличии GroupClaimFilter.user_id отдаем разрешения для указанного GroupClaimFilter.user_id и GroupClaimFilter.user_data, при отсутствии GroupClaimFilter.user_id значения берутся из токена.
   * Для admin, service при наличии GroupClaimFilter.api_key_hash возвращаем Claim с учетом только GroupClaimFilter.api_key_hash.
   * Метод доступен для: admin, master, slave, owner, employee, service, bti, seller, external_seller, ltp_first, mrf, manager
   */
  GetGroupClaimExist = (req?: GetGroupClaimExistRequestDto, init?: RequestInit): Promise<GetGroupClaimExistResponseDto> => {
    return fm.request<GetGroupClaimExistRequestDto, GetGroupClaimExistResponseDto>(`${this.host}/access_management/api/v1/group/claim/exist${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод добавления ключа доступа ApiKey.
   * Метод доступен для: admin
   */
  PutGroupApiKeyCreate = (req: PutGroupApiKeyCreateRequestDto, init?: RequestInit): Promise<PutGroupApiKeyCreateResponseDto> => {
    return fm.request<PutGroupApiKeyCreateRequestDto, PutGroupApiKeyCreateResponseDto>(`${this.host}/access_management/api/v1/group/${encodeURIComponent(req.groupId)}/api_key/create`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления ключей доступа ApiKey.
   * Метод доступен для: admin
   */
  PutGroupApiKeyDelete = (req: PutGroupApiKeyDeleteRequestDto, init?: RequestInit): Promise<PutGroupApiKeyDeleteResponseDto> => {
    return fm.request<PutGroupApiKeyDeleteRequestDto, PutGroupApiKeyDeleteResponseDto>(`${this.host}/access_management/api/v1/group/${encodeURIComponent(req.groupId)}/api_key/delete`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum GroupClaimPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type GroupClaimPagingDirectionTypeResponseEnum = keyof typeof GroupClaimPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type GroupClaimPagingDirectionTypeRequestEnum = Exclude<GroupClaimPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum GroupClaimPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По ключу атрибута
   */
  KEY = "KEY",
  /**
   * По значению атрибута
   */
  VALUE = "VALUE",
}
/**
 * Справочник типов значений сортировки.
 */
export type GroupClaimPagingOrderByTypeResponseEnum = keyof typeof GroupClaimPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type GroupClaimPagingOrderByTypeRequestEnum = Exclude<GroupClaimPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum GroupPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type GroupPagingDirectionTypeResponseEnum = keyof typeof GroupPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type GroupPagingDirectionTypeRequestEnum = Exclude<GroupPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum GroupPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
}
/**
 * Справочник типов значений сортировки.
 */
export type GroupPagingOrderByTypeResponseEnum = keyof typeof GroupPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type GroupPagingOrderByTypeRequestEnum = Exclude<GroupPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum GroupUserPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type GroupUserPagingDirectionTypeResponseEnum = keyof typeof GroupUserPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type GroupUserPagingDirectionTypeRequestEnum = Exclude<GroupUserPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum GroupUserPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору группы
   */
  GROUP_ID = "GROUP_ID",
  /**
   * По Идентификатору пользователя
   */
  USER_ID = "USER_ID",
}
/**
 * Справочник типов сортировки
 */
export type GroupUserPagingOrderByTypeResponseEnum = keyof typeof GroupUserPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type GroupUserPagingOrderByTypeRequestEnum = Exclude<GroupUserPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Атрибут пользователя
 */
export type ClaimRequestDto = {
  /**
   * Ключ атрибута
   */
  key: string
  /**
   * Значение атрибута
   */
  value?: string
}
/**
 * Атрибут пользователя
 */
export type ClaimResponseDto = {
  /**
   * Ключ атрибута
   */
  key: string
  /**
   * Значение атрибута
   */
  value: string
}
/**
 * Запрос удаления группы
 */
export type DeleteGroupRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления группы
 */
export type DeleteGroupResponseDto = {
}
/**
 * Запрос получения количества уникальных назначенных атрибутов пользователя
 */
export type GetGroupClaimCountRequestDto = {
  /**
   * Фильтр атрибутов пользователя
   */
  filter?: GroupClaimFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества уникальных назначенных атрибутов пользователя
 */
export type GetGroupClaimCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего уникальных атрибутов пользователя
   */
  readonly data: number
}>
/**
 * Запрос проверки назначенных атрибутов пользователя
 */
export type GetGroupClaimExistRequestDto = {
  /**
   * Фильтр атрибутов пользователя
   */
  filter?: GroupClaimFilterRequestDto | null
}
/**
 * Ответ на запрос проверки назначенных атрибутов пользователя
 */
export type GetGroupClaimExistResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Флаг наличия
   */
  readonly data: boolean
  /**
   * Ошибка
   */
  readonly error: GetGroupClaimExistResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetGroupClaimExistResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка пустого фильтра по атрибутам пользователя
   */
  readonly claimFilterEmpty: GetGroupClaimExistResponseErrorClaimFilterEmptyErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetGroupClaimExistResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка пустого фильтра по атрибутам пользователя
   */
  readonly claimFilterEmpty: GetGroupClaimExistResponseErrorClaimFilterEmptyErrorDto
}>
/**
 * Ошибка пустого фильтра по атрибутам пользователя
 */
export type GetGroupClaimExistResponseErrorClaimFilterEmptyErrorRequestDto = {
}
/**
 * Ошибка пустого фильтра по атрибутам пользователя
 */
export type GetGroupClaimExistResponseErrorClaimFilterEmptyErrorDto = {
}
/**
 * Запрос уникального списка назначенных атрибутов пользователя
 */
export type GetGroupClaimListRequestDto = {
  /**
   * Фильтр атрибутов пользователя
   */
  filter?: GroupClaimFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация по атрибутам пользователя
   */
  readonly paging: GroupClaimPagingRequestDto
}>
/**
 * Ответ на запрос уникального списка назначенных атрибутов пользователя
 */
export type GetGroupClaimListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Атрибут пользователя
   */
  readonly data: ClaimResponseDto
}>
/**
 * Запрос получения количества групп
 */
export type GetGroupCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: GroupFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества групп
 */
export type GetGroupCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего групп
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetGroupCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества групп
 */
export type GetGroupCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества групп
 */
export type GetGroupCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка групп
 */
export type GetGroupListRequestDto = {
  /**
   * Фильтр
   */
  filter?: GroupFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: GroupPagingRequestDto
}>
/**
 * Ответ на запрос получения списка групп
 */
export type GetGroupListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Группа
   */
  readonly data: GroupResponseDto
  /**
   * Ошибка
   */
  readonly error: GetGroupListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка групп
 */
export type GetGroupListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка групп
 */
export type GetGroupListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения группы
 */
export type GetGroupRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения группы
 */
export type GetGroupResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Группа
   */
  readonly data: GroupResponseDto
  /**
   * Ошибка
   */
  readonly error: GetGroupResponseErrorDto
}>
/**
 * Ошибка запроса получения группы
 */
export type GetGroupResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения группы
 */
export type GetGroupResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения количества связей пользователей и групп
 */
export type GetGroupUserCountRequestDto = {
  /**
   * Фильтр связей пользователей и групп
   */
  filter?: GroupUserFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей пользователей и групп
 */
export type GetGroupUserCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего связей пользователей и групп
   */
  readonly data: number
}>
/**
 * Запрос получения списка связей пользователей и групп
 */
export type GetGroupUserListRequestDto = {
  /**
   * Фильтр связей пользователей и групп
   */
  filter?: GroupUserFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: GroupUserPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей пользователей и групп
 */
export type GetGroupUserListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь пользователя и группы
   */
  readonly data: UserGroupResponseDto
}>
/**
 * Группа атрибутов пользователя
 */
export type GroupRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Описание.
   * # Диапазон: 3..256
   */
  description?: string
  /**
   * Массив атрибутов группы.
   * Эти атрибуты назначены пользователям, которые принадлежат группе.
   * # Диапазон: 0..100
   */
  claims?: ClaimRequestDto[]
  /**
   * Требования, означающие принадлежность пользователя к данной группе.
   * Пользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.
   * # Диапазон: 0..10
   */
  requirements?: ClaimRequestDto[]
  /**
   * Дата удаления группы из использования.
   * Группа не участвует в определении разрешений пользователя, если дата deleted_at непустая и уже в прошлом
   */
  deletedAt?: string | null
  /**
   * Теги группы.
   * # Диапазон: 0..10
   */
  tags?: string[]
}
/**
 * Группа атрибутов пользователя
 */
export type GroupResponseDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Описание.
   * # Диапазон: 3..256
   */
  description: string
  /**
   * Массив атрибутов группы.
   * Эти атрибуты назначены пользователям, которые принадлежат группе.
   * # Диапазон: 0..100
   */
  claims: ClaimResponseDto[]
  /**
   * Требования, означающие принадлежность пользователя к данной группе.
   * Пользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.
   * # Диапазон: 0..10
   */
  requirements: ClaimResponseDto[]
  /**
   * Дата удаления группы из использования.
   * Группа не участвует в определении разрешений пользователя, если дата deleted_at непустая и уже в прошлом
   */
  deletedAt: string | null
  /**
   * Теги группы.
   * # Диапазон: 0..10
   */
  tags: string[]
}
/**
 * Фильтр атрибутов пользователя
 */
export type GroupClaimFilterRequestDto = {
  /**
   * По идентификатору пользователя.
   * Соответствует subject, sub из JWT.
   * Для пользователя Ключа это user_id Ключа
   */
  userId?: string | null
  /**
   * По назначенным атрибутам пользователя.
   * Фильтр ограничивает возвращаемые атрибуты данным списком.
   * Возвращаем атрибуты групп, у которых Claim.key=claims[n].key И (Claim.value=claims[n].value ИЛИ claims[n].value пустой).
   * При пустом GroupClaimFilter.claims не ограничиваем выдачу, отдаем все Claims, назначенные пользователю
   */
  claims?: {[key:string]:string}
  /**
   * По условию принадлежности к группе.
   * Пользователь принадлежит группе, если user_data полностью удовлетворяет требованиям группы, то есть user_data содержит в себе Group.requirements целиком
   */
  userData?: GroupClaimFilterUserDataRequestDto | null
  /**
   * Хешированное SHA256 значение ключа доступа ApiKey
   */
  apiKeyHash?: string
}
/**
 * Фильтр атрибутов пользователя
 */
export type GroupClaimFilterResponseDto = {
  /**
   * По идентификатору пользователя.
   * Соответствует subject, sub из JWT.
   * Для пользователя Ключа это user_id Ключа
   */
  userId: string | null
  /**
   * По назначенным атрибутам пользователя.
   * Фильтр ограничивает возвращаемые атрибуты данным списком.
   * Возвращаем атрибуты групп, у которых Claim.key=claims[n].key И (Claim.value=claims[n].value ИЛИ claims[n].value пустой).
   * При пустом GroupClaimFilter.claims не ограничиваем выдачу, отдаем все Claims, назначенные пользователю
   */
  claims: {[key:string]:string}
  /**
   * По условию принадлежности к группе.
   * Пользователь принадлежит группе, если user_data полностью удовлетворяет требованиям группы, то есть user_data содержит в себе Group.requirements целиком
   */
  userData: GroupClaimFilterUserDataResponseDto | null
  /**
   * Хешированное SHA256 значение ключа доступа ApiKey
   */
  apiKeyHash: string
}
/**
 * Условие принадлежности к группе
 */
export type GroupClaimFilterUserDataRequestDto = {
  /**
   * Атрибуты пользователя, claims которого мы хотим получить
   */
  claims?: {[key:string]:string}
}
/**
 * Условие принадлежности к группе
 */
export type GroupClaimFilterUserDataResponseDto = {
  /**
   * Атрибуты пользователя, claims которого мы хотим получить
   */
  claims: {[key:string]:string}
}
/**
 * Пагинация атрибутов пользователя
 */
export type GroupClaimPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: KEY
   */
  orderByType?: GroupClaimPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: GroupClaimPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация атрибутов пользователя
 */
export type GroupClaimPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: KEY
   */
  orderByType: GroupClaimPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: GroupClaimPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Фильтр групп
 */
export type GroupFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text?: string
  /**
   * По requirements группы.
   * Возвращаем группы, у которых Group.requirements.key=GroupFilter.requirements[n].key И Group.requirements.value=GroupFilter.requirements[n].value.
   * При пустом GroupFilter.requirements[n].value возвращаем все группы, у которых Group.requirements.key=GroupFilter.requirements[n].key.
   * При передаче нескольких элементов map они работают в выборке через И
   */
  requirements?: {[key:string]:string}
  /**
   * По claims группы.
   * Возвращаем группы, у которых Group.claim.key=GroupFilter.claims[n].key И Group.claims.value=GroupFilter.claims[n].value.
   * При пустом GroupFilter.claims[n].value возвращаем все группы, у которых Group.claims.key=GroupFilter.claims[n].key.
   * При передаче нескольких элементов map они работают в выборке через И
   */
  claims?: {[key:string]:string}
  /**
   * По тегам.
   * # Диапазон: 0..10
   */
  tags?: string[]
  /**
   * Скрывать удалённые элементы.
   * Если значение — true, возвращаются только записи, у которых deleted_at = null или deleted_at > текущего времени.
   * Если значение — false или не задано, возвращаются все записи, включая удалённые
   */
  hideDeleted?: boolean | null
}
/**
 * Фильтр групп
 */
export type GroupFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text: string
  /**
   * По requirements группы.
   * Возвращаем группы, у которых Group.requirements.key=GroupFilter.requirements[n].key И Group.requirements.value=GroupFilter.requirements[n].value.
   * При пустом GroupFilter.requirements[n].value возвращаем все группы, у которых Group.requirements.key=GroupFilter.requirements[n].key.
   * При передаче нескольких элементов map они работают в выборке через И
   */
  requirements: {[key:string]:string}
  /**
   * По claims группы.
   * Возвращаем группы, у которых Group.claim.key=GroupFilter.claims[n].key И Group.claims.value=GroupFilter.claims[n].value.
   * При пустом GroupFilter.claims[n].value возвращаем все группы, у которых Group.claims.key=GroupFilter.claims[n].key.
   * При передаче нескольких элементов map они работают в выборке через И
   */
  claims: {[key:string]:string}
  /**
   * По тегам.
   * # Диапазон: 0..10
   */
  tags: string[]
  /**
   * Скрывать удалённые элементы.
   * Если значение — true, возвращаются только записи, у которых deleted_at = null или deleted_at > текущего времени.
   * Если значение — false или не задано, возвращаются все записи, включая удалённые
   */
  hideDeleted: boolean | null
}
/**
 * Пагинация групп
 */
export type GroupPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType?: GroupPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: GroupPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация групп
 */
export type GroupPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType: GroupPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: GroupPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ошибки создания группы по шаблону
 */
export type GroupTemplateNotFoundErrorRequestDto = {
  /**
   * Идентификатор шаблона группы, который не найден
   */
  groupTemplateId: string
  /**
   * Сообщение
   */
  message: string
}
/**
 * Ошибки создания группы по шаблону
 */
export type GroupTemplateNotFoundErrorResponseDto = {
  /**
   * Идентификатор шаблона группы, который не найден
   */
  groupTemplateId: string
  /**
   * Сообщение
   */
  message: string
}
/**
 * Фильтр для запроса связей пользователей и групп.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type GroupUserFilterRequestDto = {
  /**
   * По Идентификаторам группы
   */
  groupIds?: string[]
  /**
   * По Идентификаторам пользователя
   */
  userIds?: string[]
}
/**
 * Фильтр для запроса связей пользователей и групп.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type GroupUserFilterResponseDto = {
  /**
   * По Идентификаторам группы
   */
  groupIds: string[]
  /**
   * По Идентификаторам пользователя
   */
  userIds: string[]
}
/**
 * Пагинация связей пользователей и групп
 */
export type GroupUserPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: GroupUserPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: GroupUserPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация связей пользователей и групп
 */
export type GroupUserPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: GroupUserPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: GroupUserPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Запрос создания группы по шаблону
 */
export type PostGroupByTemplateRequestDto = {
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  groupTemplateId: string
  /**
   * Наименование создаваемой по шаблону группы.
   * В наименование группы будет добавлен суффикс GroupTemplate.group_title_suffix.
   * # Диапазон: 3..256
   */
  groupTitle: string
  /**
   * Специфичные для создаваемой по шаблону группы Claim requirements, они будут добавлены к requirements создаваемой по шаблону группы.
   * # Диапазон: 0..10
   */
  groupRequirements?: ClaimRequestDto[]
}
/**
 * Ответ на запрос создания группы по шаблону
 */
export type PostGroupByTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Группа
   */
  readonly data: GroupResponseDto
  /**
   * Ошибка
   */
  readonly error: PostGroupByTemplateResponseErrorDto
}>
/**
 * Ошибка запроса создания группы
 */
export type PostGroupByTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Шаблон не найден
   */
  readonly groupTemplateNotFoundError: GroupTemplateNotFoundErrorRequestDto
}>
/**
 * Ошибка запроса создания группы
 */
export type PostGroupByTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Шаблон не найден
   */
  readonly groupTemplateNotFoundError: GroupTemplateNotFoundErrorResponseDto
}>
/**
 * Запрос сохранения группы
 */
export type PostGroupRequestDto = {
  /**
   * Группа
   */
  data: GroupRequestDto
}
/**
 * Ответ на запрос сохранения группы
 */
export type PostGroupResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Группа
   */
  readonly data: GroupResponseDto
  /**
   * Ошибка
   */
  readonly error: PostGroupResponseErrorDto
}>
/**
 * Ошибка запроса сохранения группы
 */
export type PostGroupResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения группы
 */
export type PostGroupResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на добавления группе ключа доступа ApiKey
 */
export type PutGroupApiKeyCreateRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
}
/**
 * Ответ на запрос на добавления группе ключа доступа ApiKey
 */
export type PutGroupApiKeyCreateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Значение ключа доступа ApiKey.
   * # Тип: Guid
   */
  readonly data: string
}>
/**
 * Запрос на удаление ключей доступа ApiKey
 */
export type PutGroupApiKeyDeleteRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
}
/**
 * Ответ на запрос на удаление ключей доступа ApiKey
 */
export type PutGroupApiKeyDeleteResponseDto = {
}
/**
 * Запрос на добавление связи пользователя и группы
 */
export type PutGroupUserAttachRequestDto = {
  /**
   * Связь пользователя и группы
   */
  userGroup: UserGroupRequestDto
}
/**
 * Ответ на добавление связи пользователя и группы
 */
export type PutGroupUserAttachResponseDto = {
}
/**
 * Запрос на удаление связи пользователя и группы
 */
export type PutGroupUserDetachRequestDto = {
  /**
   * Связь пользователя и группы
   */
  userGroup: UserGroupRequestDto
}
/**
 * Ответ на запрос удаления точки доступа в профиль
 */
export type PutGroupUserDetachResponseDto = {
}
/**
 * Связка пользователя с группой
 */
export type UserGroupRequestDto = {
  /**
   * Идентификатор пользователя.
   * Соответствует subject, sub, client_id из JWT.
   * # Диапазон: 3..256
   */
  userId: string
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
}
/**
 * Связка пользователя с группой
 */
export type UserGroupResponseDto = {
  /**
   * Идентификатор пользователя.
   * Соответствует subject, sub, client_id из JWT.
   * # Диапазон: 3..256
   */
  userId: string
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Атрибут пользователя
   */
  "Claim": {
    "kind": "class",
    "text": "Атрибут пользователя",
    "fields": {
      /**
       * Ключ атрибута
       */
      "key": {
        "type": "string",
        "text": "Ключ атрибута",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение атрибута
       */
      "value": {
        "type": "string",
        "text": "Значение атрибута",
      },
    },
  },
  /**
   * Запрос удаления группы
   */
  "DeleteGroupRequest": {
    "kind": "class",
    "text": "Запрос удаления группы",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления группы
   */
  "DeleteGroupResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления группы",
  },
  /**
   * Запрос получения количества уникальных назначенных атрибутов пользователя
   */
  "GetGroupClaimCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества уникальных назначенных атрибутов пользователя",
    "fields": {
      /**
       * Фильтр атрибутов пользователя
       */
      "filter": {
        "type": "GroupClaimFilter",
        "text": "Фильтр атрибутов пользователя",
      },
    },
  },
  /**
   * Ответ на запрос получения количества уникальных назначенных атрибутов пользователя
   */
  "GetGroupClaimCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества уникальных назначенных атрибутов пользователя",
    "fields": {
      /**
       * Всего уникальных атрибутов пользователя
       */
      "data": {
        "type": "int32",
        "text": "Всего уникальных атрибутов пользователя",
      },
    },
  },
  /**
   * Запрос проверки назначенных атрибутов пользователя
   */
  "GetGroupClaimExistRequest": {
    "kind": "class",
    "text": "Запрос проверки назначенных атрибутов пользователя",
    "fields": {
      /**
       * Фильтр атрибутов пользователя
       */
      "filter": {
        "type": "GroupClaimFilter",
        "text": "Фильтр атрибутов пользователя",
      },
    },
  },
  /**
   * Ответ на запрос проверки назначенных атрибутов пользователя
   */
  "GetGroupClaimExistResponse": {
    "kind": "class",
    "text": "Ответ на запрос проверки назначенных атрибутов пользователя",
    "fields": {
      /**
       * Флаг наличия
       */
      "data": {
        "type": "bool",
        "text": "Флаг наличия",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupClaimExistResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetGroupClaimExistResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка пустого фильтра по атрибутам пользователя
       */
      "claimFilterEmpty": {
        "type": "GetGroupClaimExistResponse.Error.ClaimFilterEmptyError",
        "text": "Ошибка пустого фильтра по атрибутам пользователя",
      },
    },
  },
  /**
   * Ошибка пустого фильтра по атрибутам пользователя
   */
  "GetGroupClaimExistResponse.Error.ClaimFilterEmptyError": {
    "kind": "class",
    "text": "Ошибка пустого фильтра по атрибутам пользователя",
  },
  /**
   * Запрос уникального списка назначенных атрибутов пользователя
   */
  "GetGroupClaimListRequest": {
    "kind": "class",
    "text": "Запрос уникального списка назначенных атрибутов пользователя",
    "fields": {
      /**
       * Фильтр атрибутов пользователя
       */
      "filter": {
        "type": "GroupClaimFilter",
        "text": "Фильтр атрибутов пользователя",
      },
      /**
       * Пагинация по атрибутам пользователя
       */
      "paging": {
        "type": "GroupClaimPaging",
        "text": "Пагинация по атрибутам пользователя",
      },
    },
  },
  /**
   * Ответ на запрос уникального списка назначенных атрибутов пользователя
   */
  "GetGroupClaimListResponse": {
    "kind": "class",
    "text": "Ответ на запрос уникального списка назначенных атрибутов пользователя",
    "fields": {
      /**
       * Атрибут пользователя
       */
      "data": {
        "type": "Claim",
        "text": "Атрибут пользователя",
      },
    },
  },
  /**
   * Запрос получения количества групп
   */
  "GetGroupCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества групп",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "GroupFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества групп
   */
  "GetGroupCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества групп",
    "fields": {
      /**
       * Всего групп
       */
      "data": {
        "type": "int32",
        "text": "Всего групп",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества групп
   */
  "GetGroupCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества групп",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка групп
   */
  "GetGroupListRequest": {
    "kind": "class",
    "text": "Запрос получения списка групп",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "GroupFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "GroupPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка групп
   */
  "GetGroupListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка групп",
    "fields": {
      /**
       * Группа
       */
      "data": {
        "type": "Group",
        "text": "Группа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка групп
   */
  "GetGroupListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка групп",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения группы
   */
  "GetGroupRequest": {
    "kind": "class",
    "text": "Запрос получения группы",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения группы
   */
  "GetGroupResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения группы",
    "fields": {
      /**
       * Группа
       */
      "data": {
        "type": "Group",
        "text": "Группа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения группы
   */
  "GetGroupResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества связей пользователей и групп
   */
  "GetGroupUserCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей пользователей и групп",
    "fields": {
      /**
       * Фильтр связей пользователей и групп
       */
      "filter": {
        "type": "GroupUserFilter",
        "text": "Фильтр связей пользователей и групп",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей пользователей и групп
   */
  "GetGroupUserCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей пользователей и групп",
    "fields": {
      /**
       * Всего связей пользователей и групп
       */
      "data": {
        "type": "int32",
        "text": "Всего связей пользователей и групп",
      },
    },
  },
  /**
   * Запрос получения списка связей пользователей и групп
   */
  "GetGroupUserListRequest": {
    "kind": "class",
    "text": "Запрос получения списка связей пользователей и групп",
    "fields": {
      /**
       * Фильтр связей пользователей и групп
       */
      "filter": {
        "type": "GroupUserFilter",
        "text": "Фильтр связей пользователей и групп",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "GroupUserPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей пользователей и групп
   */
  "GetGroupUserListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей пользователей и групп",
    "fields": {
      /**
       * Связь пользователя и группы
       */
      "data": {
        "type": "UserGroup",
        "text": "Связь пользователя и группы",
      },
    },
  },
  /**
   * Группа атрибутов пользователя
   */
  "Group": {
    "kind": "class",
    "text": "Группа атрибутов пользователя",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
      },
      /**
       * Наименование.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Описание.
       * # Диапазон: 3..256
       */
      "description": {
        "type": "string",
        "text": "Описание.\n# Диапазон: 3..256",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Массив атрибутов группы.
       * Эти атрибуты назначены пользователям, которые принадлежат группе.
       * # Диапазон: 0..100
       */
      "claims": {
        "type": "Claim",
        "text": "Массив атрибутов группы.\nЭти атрибуты назначены пользователям, которые принадлежат группе.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Требования, означающие принадлежность пользователя к данной группе.
       * Пользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.
       * # Диапазон: 0..10
       */
      "requirements": {
        "type": "Claim",
        "text": "Требования, означающие принадлежность пользователя к данной группе.\nПользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.\n# Диапазон: 0..10",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
      /**
       * Дата удаления группы из использования.
       * Группа не участвует в определении разрешений пользователя, если дата deleted_at непустая и уже в прошлом
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления группы из использования.\nГруппа не участвует в определении разрешений пользователя, если дата deleted_at непустая и уже в прошлом",
      },
      /**
       * Теги группы.
       * # Диапазон: 0..10
       */
      "tags": {
        "type": "string",
        "text": "Теги группы.\n# Диапазон: 0..10",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
    },
  },
  /**
   * Фильтр атрибутов пользователя
   */
  "GroupClaimFilter": {
    "kind": "class",
    "text": "Фильтр атрибутов пользователя",
    "fields": {
      /**
       * По идентификатору пользователя.
       * Соответствует subject, sub из JWT.
       * Для пользователя Ключа это user_id Ключа
       */
      "userId": {
        "type": "google.protobuf.StringValue",
        "text": "По идентификатору пользователя.\nСоответствует subject, sub из JWT.\nДля пользователя Ключа это user_id Ключа",
      },
      /**
       * По назначенным атрибутам пользователя.
       * Фильтр ограничивает возвращаемые атрибуты данным списком.
       * Возвращаем атрибуты групп, у которых Claim.key=claims[n].key И (Claim.value=claims[n].value ИЛИ claims[n].value пустой).
       * При пустом GroupClaimFilter.claims не ограничиваем выдачу, отдаем все Claims, назначенные пользователю
       */
      "claims": {
        "type": "{[key:string]:string}",
        "text": "По назначенным атрибутам пользователя.\nФильтр ограничивает возвращаемые атрибуты данным списком.\nВозвращаем атрибуты групп, у которых Claim.key=claims[n].key И (Claim.value=claims[n].value ИЛИ claims[n].value пустой).\nПри пустом GroupClaimFilter.claims не ограничиваем выдачу, отдаем все Claims, назначенные пользователю",
      },
      /**
       * По условию принадлежности к группе.
       * Пользователь принадлежит группе, если user_data полностью удовлетворяет требованиям группы, то есть user_data содержит в себе Group.requirements целиком
       */
      "userData": {
        "type": "GroupClaimFilter.UserData",
        "text": "По условию принадлежности к группе.\nПользователь принадлежит группе, если user_data полностью удовлетворяет требованиям группы, то есть user_data содержит в себе Group.requirements целиком",
      },
      /**
       * Хешированное SHA256 значение ключа доступа ApiKey
       */
      "apiKeyHash": {
        "type": "string",
        "text": "Хешированное SHA256 значение ключа доступа ApiKey",
      },
    },
  },
  /**
   * Условие принадлежности к группе
   */
  "GroupClaimFilter.UserData": {
    "kind": "class",
    "text": "Условие принадлежности к группе",
    "fields": {
      /**
       * Атрибуты пользователя, claims которого мы хотим получить
       */
      "claims": {
        "type": "{[key:string]:string}",
        "text": "Атрибуты пользователя, claims которого мы хотим получить",
      },
    },
  },
  /**
   * Пагинация атрибутов пользователя
   */
  "GroupClaimPaging": {
    "kind": "class",
    "text": "Пагинация атрибутов пользователя",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: KEY
       */
      "orderByType": {
        "type": "GroupClaimPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: KEY",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "GroupClaimPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр групп
   */
  "GroupFilter": {
    "kind": "class",
    "text": "Фильтр групп",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование
       */
      "text": {
        "type": "string",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По requirements группы.
       * Возвращаем группы, у которых Group.requirements.key=GroupFilter.requirements[n].key И Group.requirements.value=GroupFilter.requirements[n].value.
       * При пустом GroupFilter.requirements[n].value возвращаем все группы, у которых Group.requirements.key=GroupFilter.requirements[n].key.
       * При передаче нескольких элементов map они работают в выборке через И
       */
      "requirements": {
        "type": "{[key:string]:string}",
        "text": "По requirements группы.\nВозвращаем группы, у которых Group.requirements.key=GroupFilter.requirements[n].key И Group.requirements.value=GroupFilter.requirements[n].value.\nПри пустом GroupFilter.requirements[n].value возвращаем все группы, у которых Group.requirements.key=GroupFilter.requirements[n].key.\nПри передаче нескольких элементов map они работают в выборке через И",
      },
      /**
       * По claims группы.
       * Возвращаем группы, у которых Group.claim.key=GroupFilter.claims[n].key И Group.claims.value=GroupFilter.claims[n].value.
       * При пустом GroupFilter.claims[n].value возвращаем все группы, у которых Group.claims.key=GroupFilter.claims[n].key.
       * При передаче нескольких элементов map они работают в выборке через И
       */
      "claims": {
        "type": "{[key:string]:string}",
        "text": "По claims группы.\nВозвращаем группы, у которых Group.claim.key=GroupFilter.claims[n].key И Group.claims.value=GroupFilter.claims[n].value.\nПри пустом GroupFilter.claims[n].value возвращаем все группы, у которых Group.claims.key=GroupFilter.claims[n].key.\nПри передаче нескольких элементов map они работают в выборке через И",
      },
      /**
       * По тегам.
       * # Диапазон: 0..10
       */
      "tags": {
        "type": "string",
        "text": "По тегам.\n# Диапазон: 0..10",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
      /**
       * Скрывать удалённые элементы.
       * Если значение — true, возвращаются только записи, у которых deleted_at = null или deleted_at > текущего времени.
       * Если значение — false или не задано, возвращаются все записи, включая удалённые
       */
      "hideDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Скрывать удалённые элементы.\nЕсли значение — true, возвращаются только записи, у которых deleted_at = null или deleted_at > текущего времени.\nЕсли значение — false или не задано, возвращаются все записи, включая удалённые",
      },
    },
  },
  /**
   * Пагинация групп
   */
  "GroupPaging": {
    "kind": "class",
    "text": "Пагинация групп",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ID
       */
      "orderByType": {
        "type": "GroupPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "GroupPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибки создания группы по шаблону
   */
  "GroupTemplateNotFoundError": {
    "kind": "class",
    "text": "Ошибки создания группы по шаблону",
    "fields": {
      /**
       * Идентификатор шаблона группы, который не найден
       */
      "groupTemplateId": {
        "type": "string",
        "text": "Идентификатор шаблона группы, который не найден",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сообщение
       */
      "message": {
        "type": "string",
        "text": "Сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса связей пользователей и групп.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "GroupUserFilter": {
    "kind": "class",
    "text": "Фильтр для запроса связей пользователей и групп.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификаторам группы
       */
      "groupIds": {
        "type": "string",
        "text": "По Идентификаторам группы",
      },
      /**
       * По Идентификаторам пользователя
       */
      "userIds": {
        "type": "string",
        "text": "По Идентификаторам пользователя",
      },
    },
  },
  /**
   * Пагинация связей пользователей и групп
   */
  "GroupUserPaging": {
    "kind": "class",
    "text": "Пагинация связей пользователей и групп",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "GroupUserPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "GroupUserPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Запрос создания группы по шаблону
   */
  "PostGroupByTemplateRequest": {
    "kind": "class",
    "text": "Запрос создания группы по шаблону",
    "fields": {
      /**
       * Идентификатор шаблона группы.
       * # Тип: Guid
       */
      "groupTemplateId": {
        "type": "string",
        "text": "Идентификатор шаблона группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Наименование создаваемой по шаблону группы.
       * В наименование группы будет добавлен суффикс GroupTemplate.group_title_suffix.
       * # Диапазон: 3..256
       */
      "groupTitle": {
        "type": "string",
        "text": "Наименование создаваемой по шаблону группы.\nВ наименование группы будет добавлен суффикс GroupTemplate.group_title_suffix.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Специфичные для создаваемой по шаблону группы Claim requirements, они будут добавлены к requirements создаваемой по шаблону группы.
       * # Диапазон: 0..10
       */
      "groupRequirements": {
        "type": "Claim",
        "text": "Специфичные для создаваемой по шаблону группы Claim requirements, они будут добавлены к requirements создаваемой по шаблону группы.\n# Диапазон: 0..10",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос создания группы по шаблону
   */
  "PostGroupByTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания группы по шаблону",
    "fields": {
      /**
       * Группа
       */
      "data": {
        "type": "Group",
        "text": "Группа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostGroupByTemplateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса создания группы
   */
  "PostGroupByTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса создания группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Шаблон не найден
       */
      "groupTemplateNotFoundError": {
        "type": "GroupTemplateNotFoundError",
        "text": "Шаблон не найден",
      },
    },
  },
  /**
   * Запрос сохранения группы
   */
  "PostGroupRequest": {
    "kind": "class",
    "text": "Запрос сохранения группы",
    "fields": {
      /**
       * Группа
       */
      "data": {
        "type": "Group",
        "text": "Группа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения группы
   */
  "PostGroupResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения группы",
    "fields": {
      /**
       * Группа
       */
      "data": {
        "type": "Group",
        "text": "Группа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostGroupResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения группы
   */
  "PostGroupResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на добавления группе ключа доступа ApiKey
   */
  "PutGroupApiKeyCreateRequest": {
    "kind": "class",
    "text": "Запрос на добавления группе ключа доступа ApiKey",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на добавления группе ключа доступа ApiKey
   */
  "PutGroupApiKeyCreateResponse": {
    "kind": "class",
    "text": "Ответ на запрос на добавления группе ключа доступа ApiKey",
    "fields": {
      /**
       * Значение ключа доступа ApiKey.
       * # Тип: Guid
       */
      "data": {
        "type": "string",
        "text": "Значение ключа доступа ApiKey.\n# Тип: Guid",
      },
    },
  },
  /**
   * Запрос на удаление ключей доступа ApiKey
   */
  "PutGroupApiKeyDeleteRequest": {
    "kind": "class",
    "text": "Запрос на удаление ключей доступа ApiKey",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на удаление ключей доступа ApiKey
   */
  "PutGroupApiKeyDeleteResponse": {
    "kind": "class",
    "text": "Ответ на запрос на удаление ключей доступа ApiKey",
  },
  /**
   * Запрос на добавление связи пользователя и группы
   */
  "PutGroupUserAttachRequest": {
    "kind": "class",
    "text": "Запрос на добавление связи пользователя и группы",
    "fields": {
      /**
       * Связь пользователя и группы
       */
      "userGroup": {
        "type": "UserGroup",
        "text": "Связь пользователя и группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на добавление связи пользователя и группы
   */
  "PutGroupUserAttachResponse": {
    "kind": "class",
    "text": "Ответ на добавление связи пользователя и группы",
  },
  /**
   * Запрос на удаление связи пользователя и группы
   */
  "PutGroupUserDetachRequest": {
    "kind": "class",
    "text": "Запрос на удаление связи пользователя и группы",
    "fields": {
      /**
       * Связь пользователя и группы
       */
      "userGroup": {
        "type": "UserGroup",
        "text": "Связь пользователя и группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления точки доступа в профиль
   */
  "PutGroupUserDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления точки доступа в профиль",
  },
  /**
   * Связка пользователя с группой
   */
  "UserGroup": {
    "kind": "class",
    "text": "Связка пользователя с группой",
    "fields": {
      /**
       * Идентификатор пользователя.
       * Соответствует subject, sub, client_id из JWT.
       * # Диапазон: 3..256
       */
      "userId": {
        "type": "string",
        "text": "Идентификатор пользователя.\nСоответствует subject, sub, client_id из JWT.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "GroupClaimPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "GroupClaimPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По ключу атрибута
       */
      "KEY": {
        "i": 1,
        "text": "По ключу атрибута",
      },
      /**
       * По значению атрибута
       */
      "VALUE": {
        "i": 2,
        "text": "По значению атрибута",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "GroupPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "GroupPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "GroupUserPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "GroupUserPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору группы
       */
      "GROUP_ID": {
        "i": 1,
        "text": "По Идентификатору группы",
      },
      /**
       * По Идентификатору пользователя
       */
      "USER_ID": {
        "i": 2,
        "text": "По Идентификатору пользователя",
      },
    },
  },
}